import { UseI18nHook } from "@core/i18n/i18n";
import { UseNavigationHook } from "@core/routing/use-navigate";
import { Notification, PatientNotificationData } from "@domain/notification/notification";
import { RoutesPath, TabPatientDetails } from "@ui/navigation/routes";
import { formatName } from "@utils/string-utils";

export class PatientProgramStartedNotification extends Notification {
	private get data() {
		return this.notification.data as { patient: PatientNotificationData; program: { name: string } };
	}

	format({ format }: UseI18nHook): string {
		return format("global.notifications.patientProgram.started", {
			patientName: formatName(this.data.patient),
			programName: this.data.program.name,
		});
	}

	onClick(navigate: UseNavigationHook): void {
		navigate(RoutesPath.PatientDetails, {
			route: { patientId: this.data.patient.id },
			query: { active: TabPatientDetails.PROGRESS_TAB },
		});
	}
}
